import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function WRDysport() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-2306">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2307">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2308">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-2309">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden shadow-xl" data-id="element-2310">
              <img src="https://cdn.magicpatterns.com/uploads/mWor9bFG8MpnTs2KAmQMrW/AdobeStock_257206406-6.webp" alt="Be CLINICAL Treatment Room - Dysport" className="w-full h-full object-cover" data-id="element-2311" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2312">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2313">
              TREATMENT OPTION
            </span>

            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-2314">
              WHAT IS DYSPORT?
            </h2>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body mb-12" data-id="element-2315">
              <p data-id="element-2316">
                Dysport is a form of botulinum toxin type A. Similar to Botox
                and Xeomin, Dysport by Galderma is used for cosmetic purposes to
                temporarily improve the appearance of moderate to severe frown
                lines between the eyebrows (glabellar lines) in adults. It is
                injected into specific facial muscles to reduce muscle activity
                and, consequently, diminish the appearance of wrinkles and fine
                lines.
              </p>
              <p data-id="element-2317">
                The mechanism of action of Dysport is comparable to Botox—it
                temporarily blocks nerve signals in the muscles, preventing them
                from contracting and causing wrinkles. Some individuals may
                experience a quicker onset of action with Dysport compared to
                Botox, with results becoming noticeable within a few days after
                treatment.
              </p>
            </div>

            {/* Editorial Divider */}
            <div className="text-center py-6 border-y border-[#222222]" data-id="element-2318">
              <p className="font-serif italic text-[#FF1493] text-[28px]" data-id="element-2319">
                Treat yourself!
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}